import { create } from 'zustand';

/**
 * Cursor state for the review cockpit.
 *
 * This is intentionally a NEW store rather than an addition to `useReviewStore`
 * (existing store shapes are not modified). It tracks only the active question
 * — the one whose evidence is shown in the right-hand pane. Selection for bulk
 * actions stays in `useReviewStore`; the active cursor is a separate concern.
 */
interface CockpitState {
  activeQuestionId: string | null;
  setActiveQuestion: (questionId: string | null) => void;
}

export const useCockpitStore = create<CockpitState>((set) => ({
  activeQuestionId: null,
  setActiveQuestion: (activeQuestionId) => set({ activeQuestionId }),
}));
